import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-42bcefb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { IonInput, IonItem, IonLabel } from '@ionic/vue';
import { useQualityStepStore } from '@/store/qualityStep';
import SelectOption from '@/types/SelectOption';
import { QualityMaterial } from '@/enums/Quality';
import { carbonSteelVariant, saeGradeVariant, stainlessSteelVariant } from '@/data/QualityValues';
import useTranslateEnums from '@/composables/useTranslateEnums';
import DropdownSelect from '@/components/DropdownSelect.vue';
import SegmentSelect from '@/components/SegmentSelect.vue';
import ComputeWizardStepContainer from '@/components/ComputeWizard/ComputeWizardStepContainer.vue';
import ComputeWizardInputAccordion from '@/components/ComputeWizard/ComputeWizardInputAccordion.vue';
import useLangSettings from '@/composables/useLangSettings';
import { TranslateElement } from '@/types/TranslateElement';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeWizardQuality',
  emits: ['requestNextStep'],
  setup(__props) {



const { t } = useI18n();
const { translate } = useTranslateEnums();
const qualityStepStore = useQualityStepStore();

const grades = computed((): Array<TranslateElement> => {
  return translate(QualityMaterial, 'quality.grades');
});

const qualityVariantForGrade = (grade: QualityMaterial) => {
  switch (grade) {
    case QualityMaterial.StainlessSteel:
      return stainlessSteelVariant;
    case QualityMaterial.SaeGrade:
      return saeGradeVariant;
    default:
      return carbonSteelVariant;
  }
};

const stepSchemaImage = computed(() => {
  return require(`@/assets/images/step-schemas/property-class-${useLangSettings().currentLocale()}.png`);
});

const variantOptions: ComputedRef<Array<SelectOption>> = computed(() => {
  const selectedMaterial = qualityStepStore.selectedMaterial;
  if (selectedMaterial === undefined || selectedMaterial.toString() === '') {
    return [];
  }

  return qualityVariantForGrade(selectedMaterial).map((element) => {
    return { label: t(`quality.grade_variants.${selectedMaterial}.${element.variant}`), value: element.variant };
  });
});

const dropDownLabel = computed(() => {
  if (!qualityStepStore.selectedMaterial || !qualityStepStore.selectedGradeVariant) {
    return t('quality.grade_variants.grade_variant_input_label');
  }

  return t(`quality.grade_variants.${qualityStepStore.selectedMaterial}.${qualityStepStore.selectedGradeVariant}`);
});

const onDisplayedMaterialChange = (event: QualityMaterial | undefined) => {
  qualityStepStore.setSelectedMaterial(event);
};

const onSpecificValueChange = (event: CustomEvent) => {
  qualityStepStore.setSpecificValue(event.detail.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputeWizardStepContainer, { class: "compute-wizard-quality" }, {
    default: _withCtx(() => [
      _createVNode(SegmentSelect, {
        onOnChange: onDisplayedMaterialChange,
        modelValue: _unref(qualityStepStore).selectedMaterial,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(qualityStepStore).selectedMaterial) = $event)),
        class: "compute-wizard-quality__grade",
        options: grades.value
      }, null, 8, ["modelValue", "options"]),
      _createVNode(DropdownSelect, {
        class: "compute-wizard-quality__grade-variant",
        label: dropDownLabel.value,
        modelValue: _unref(qualityStepStore).selectedGradeVariant,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(qualityStepStore).selectedGradeVariant) = $event)),
        options: variantOptions.value
      }, null, 8, ["label", "modelValue", "options"]),
      _createElementVNode("img", {
        class: "compute-wizard-quality__image",
        src: stepSchemaImage.value
      }, null, 8, _hoisted_1),
      _createVNode(ComputeWizardInputAccordion, {
        class: "compute-wizard-quality__input-accordion",
        title: _ctx.$t('quality.specific_settings.accordion_label')
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), {
            lines: "full",
            class: "compute-wizard-quality__input-accordion-item",
            slot: "content"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), { class: "compute-wizard-quality__input-accordion-label" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('quality.specific_settings.input_label')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonInput), {
                class: "compute-wizard-quality__input-accordion-input",
                type: "number",
                inputMode: "decimal",
                pattern: "[0-9]*",
                step: "1",
                min: "1",
                modelValue: _unref(qualityStepStore).specificValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(qualityStepStore).specificValue) = $event)),
                placeholder: "x",
                onIonChange: onSpecificValueChange,
                enterkeyhint: "done",
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('requestNextStep')), ["enter"]))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})